module.exports = __webpack_public_path__ + "img/dog-leashed.b3f7c65c.svg";